exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 1200px){\n    .container {\n        max-width: 700px;\n    }\n}\n\n@media (min-width: 992px){\n    .container {\n        max-width: 700px;\n    }\n}\n\na.panel-link{\n    padding: 0 4.5%;\n    border-right: 1px solid;\n }\n\na.panel-link-end {\n    padding: 0 4.5%;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/esign/esign.component.css
// module id = ../../../../../src/app/esign/esign.component.css
// module chunks = main